<template>
<div>
  <b-row>
    <b-col cols="6">
      <b-form-group label="Disabled">
          <b-form-checkbox
            v-model="activeField.disabled"
            switch></b-form-checkbox>
      </b-form-group>
    </b-col>

    <b-col cols="6">
      <b-form-group label="Multiple">
          <b-form-checkbox
            v-model="activeField.multiple"
            switch></b-form-checkbox>
      </b-form-group>
    </b-col>
  </b-row>
</div>
</template>

<script>
export default {
  name: 'SelectListAdvancedProp',
  store: ['activeField'],
  methods: {
    remoteChange(value) {
      if (value) {
        this.activeField.filterable = true;
        this.activeField.isFromUrl = true;
      }
    }
  }
}

</script>
